import React from "react";

export const ReferalsTotalCountBottomBlock = () => {
  return (
    <svg viewBox="0 0 353 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M284 13L288.775 8.41967H305.511L312.202 2H341L333.412 9.27323L329.53 13H284Z"
        fill="#2A1E54"
      />
      <path
        d="M69 13L64.2254 8.41967H47.4894L40.7979 2H12L19.5883 9.27323L23.4702 13H69Z"
        fill="#2A1E54"
      />
      <path
        d="M309 2L305.168 5.66667H286.002L278.334 13H217L220.834 9.33334H278.334L286.002 2H309Z"
        fill="#7F5CFF"
      />
      <path
        d="M44 2L47.8317 5.66667H66.9984L74.666 13H136L132.166 9.33334H74.666L66.9984 2H44Z"
        fill="#7F5CFF"
      />
      <rect
        x="177"
        y="0.707107"
        width="17"
        height="17"
        transform="rotate(45 177 0.707107)"
        fill="url(#paint0_radial_2039_7777)"
        stroke="#7F5CFF"
      />
      <path
        d="M177.062 17.9478C177.09 17.9182 177.441 17.5548 177.844 17.1407C178.247 16.7265 178.683 16.2772 178.813 16.142C178.942 16.0067 179.174 15.7659 179.33 15.6067C179.483 15.4475 179.739 15.1855 179.897 15.0221C180.224 14.684 180.204 14.7052 180.989 13.8966C181.887 12.9726 182 12.8556 182 12.843C182 12.8373 181.218 12.8317 180.263 12.8317H178.525V9.91585V7H178.299H178.07L178.062 7.15917C178.056 7.2451 178.052 8.66922 178.052 10.3201V13.3247L179.251 13.3275L180.449 13.3318L180.034 13.7543C179.806 13.9868 179.384 14.4108 179.097 14.6981L178.573 15.2193L178.5 15.1418L178.425 15.0644L177.714 15.7687L177.004 16.473L176.511 15.9842C176.001 15.4813 175.434 14.9038 175.228 14.6812L175.11 14.5544L175.164 14.5023L175.219 14.4502L175.562 14.7995C175.75 14.9911 176.06 15.3038 176.251 15.494C176.442 15.6842 176.688 15.9307 176.798 16.042L176.998 16.2434L177.269 15.9715C177.42 15.8222 177.831 15.4137 178.184 15.0644L178.826 14.4305L178.903 14.5051L178.979 14.5798L179.064 14.4911C179.11 14.4418 179.351 14.2009 179.598 13.9558C179.845 13.7107 180.047 13.5064 180.047 13.5022C180.047 13.498 179.564 13.4938 178.971 13.4938H177.894L177.891 10.2511L177.887 7.00704L177.516 7.00282L177.147 7V7.93673V8.87347L176.927 9.09603C176.807 9.21717 176.662 9.36649 176.604 9.42706L176.501 9.53552V11.4062L176.503 13.2754L176.573 13.3078C176.675 13.3543 176.722 13.436 176.714 13.5487C176.709 13.6121 176.698 13.6445 176.668 13.6825C176.62 13.7445 176.534 13.7896 176.462 13.7896C176.412 13.791 176.392 13.8051 176.228 13.96L176.049 14.129L175.727 13.8121L175.406 13.4938H174.683C174.286 13.4938 173.96 13.498 173.96 13.5036C173.96 13.5092 174.085 13.6374 174.237 13.7896C174.389 13.9403 174.673 14.2262 174.87 14.4234C175.067 14.6207 175.295 14.8489 175.377 14.932L175.526 15.0799L175.47 15.1376L175.413 15.1954L175.128 14.9122C174.972 14.7559 174.705 14.4882 174.534 14.3178C174.365 14.1474 174.079 13.8614 173.898 13.6825C173.719 13.5036 173.572 13.3487 173.572 13.3402C173.572 13.3289 173.892 13.3247 174.764 13.3247H175.955V10.1624V7H175.711H175.467V9.91585V12.8317L173.734 12.8345L172 12.8387L172.085 12.9303C172.169 13.0219 172.579 13.4445 172.876 13.7473C172.963 13.8361 173.139 14.0164 173.263 14.1488C173.564 14.4601 174.393 15.3123 174.813 15.7391C174.995 15.9236 175.147 16.08 175.151 16.0856C175.159 16.0969 175.434 16.38 175.891 16.8477C176.017 16.9773 176.317 17.29 176.559 17.5407C176.8 17.7929 177.001 17.9999 177.005 17.9999C177.011 18.0013 177.037 17.9774 177.062 17.9478ZM176.963 17.0759C176.945 17.0533 176.705 16.8139 176.428 16.542C176.152 16.2716 175.927 16.0391 175.927 16.0279C175.927 16.0166 175.95 15.9842 175.978 15.9574L176.03 15.9095L176.514 16.3927L176.998 16.8759L177.182 16.6927C177.282 16.5927 177.499 16.3758 177.663 16.211L177.96 15.911L178.02 15.9729L178.08 16.0363L177.933 16.1842C177.852 16.2659 177.615 16.5012 177.406 16.7096C177.196 16.9167 177.022 17.0928 177.021 17.0998C177.012 17.1224 176.999 17.1167 176.963 17.0759ZM176.67 15.4306C176.448 15.2066 176.421 15.1841 176.376 15.1841C176.35 15.1841 176.307 15.1757 176.28 15.1644C176.231 15.1447 176.142 15.0503 176.142 15.0193C176.142 15.0094 175.95 14.8094 175.713 14.5756L175.284 14.1502L175.262 14.1938C175.233 14.246 175.156 14.2939 175.078 14.3051C174.962 14.3234 174.82 14.2305 174.798 14.1206C174.777 14.0079 174.834 13.8839 174.926 13.8417C174.996 13.8079 175.118 13.8107 175.177 13.8459C175.205 13.8628 175.436 14.0783 175.691 14.3277L176.156 14.7798L176.238 14.7052C176.284 14.6643 176.447 14.5066 176.597 14.3544L176.874 14.0783V12.064L176.876 10.0497L176.979 9.93839L177.084 9.82711L177.024 9.76654C176.857 9.60454 176.973 9.33832 177.21 9.33832C177.261 9.33832 177.347 9.37353 177.387 9.41156L177.42 9.44114V9.12139V8.80022L177.383 8.77064C177.335 8.73542 177.276 8.61287 177.278 8.55653C177.279 8.45511 177.341 8.36636 177.439 8.3227C177.515 8.2903 177.569 8.28889 177.642 8.3227C177.752 8.37059 177.819 8.48892 177.799 8.59315C177.777 8.70443 177.706 8.78895 177.617 8.81008L177.578 8.81994V11.4639V14.1065L177.114 14.5671C176.86 14.8207 176.636 15.0475 176.617 15.0714L176.584 15.1151L176.754 15.2841L176.925 15.4531L177.067 15.3081C177.144 15.2278 177.328 15.0432 177.476 14.8953C177.622 14.7488 177.757 14.6108 177.776 14.5911L177.808 14.5544L177.759 14.5037C177.7 14.4418 177.671 14.3417 177.691 14.2699C177.711 14.2037 177.773 14.1305 177.831 14.1037C177.878 14.0812 177.879 14.0769 177.879 13.998V13.9163H178.332C178.702 13.9163 178.784 13.9135 178.794 13.8966C178.81 13.8699 178.897 13.822 178.952 13.8107C179.048 13.791 179.173 13.8572 179.216 13.9501C179.307 14.1445 179.134 14.3516 178.927 14.2967C178.85 14.2755 178.777 14.2107 178.747 14.1347L178.722 14.0713H178.388C178.202 14.0713 178.052 14.0769 178.052 14.0826C178.052 14.0896 178.067 14.1037 178.088 14.1135C178.106 14.1234 178.141 14.1572 178.162 14.1882C178.195 14.2347 178.202 14.26 178.202 14.3319C178.202 14.4361 178.168 14.4953 178.067 14.5629C178.011 14.5995 177.664 14.9418 177.084 15.5334C177.005 15.6123 176.936 15.6771 176.929 15.6771C176.922 15.6771 176.805 15.5658 176.67 15.4306Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.462 14.9897C176.511 14.9376 176.482 14.8629 176.406 14.8404C176.366 14.8277 176.3 14.8798 176.3 14.9249C176.3 15.001 176.412 15.0447 176.462 14.9897Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.03 14.4164L177.42 14.029V11.895C177.42 10.5356 177.416 9.76231 177.406 9.76794C177.399 9.77217 177.329 9.84542 177.248 9.92994L177.105 10.0835V12.0865V14.0896L176.82 14.3727C176.665 14.5291 176.529 14.6615 176.517 14.6685C176.503 14.677 176.513 14.6939 176.56 14.7418C176.595 14.7756 176.626 14.8038 176.632 14.8038C176.636 14.8038 176.816 14.6291 177.03 14.4164Z"
        fill="#C6B7FF"
      />
      <path
        d="M178.008 14.3953C178.046 14.3586 178.044 14.3108 178.007 14.2699C177.968 14.2291 177.912 14.2361 177.876 14.284C177.849 14.3178 177.849 14.3234 177.871 14.3629C177.905 14.4291 177.961 14.4418 178.008 14.3953Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.047 14.1164C179.081 14.0797 179.077 14.0206 179.04 13.9952C178.994 13.9642 178.948 13.967 178.922 14.0037C178.892 14.0459 178.893 14.0797 178.928 14.1135C178.964 14.1488 179.017 14.1502 179.047 14.1164Z"
        fill="#C6B7FF"
      />
      <path
        d="M175.106 14.1248C175.133 14.098 175.127 14.0234 175.096 13.9952C175.058 13.9614 175.009 13.9713 174.974 14.0192C174.946 14.0558 174.946 14.0614 174.966 14.0966C174.982 14.1248 175.001 14.1361 175.037 14.1389C175.064 14.1417 175.096 14.1347 175.106 14.1248Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.275 9.65668C177.285 9.64541 177.291 9.61583 177.288 9.58907C177.28 9.50173 177.161 9.4792 177.119 9.55667C177.102 9.58907 177.102 9.59893 177.122 9.63133C177.14 9.66091 177.159 9.67077 177.202 9.67359C177.238 9.6764 177.264 9.67077 177.275 9.65668Z"
        fill="#C6B7FF"
      />
      <path
        d="M177.614 8.61428C177.662 8.54103 177.594 8.44806 177.51 8.47483C177.415 8.50582 177.437 8.63682 177.538 8.64527C177.581 8.6495 177.595 8.64386 177.614 8.61428Z"
        fill="#C6B7FF"
      />
      <path
        d="M178.73 17.9351C178.743 17.9239 178.743 17.4154 178.73 17.1801L178.721 16.9998L178.569 17.004L178.417 17.0083L178.413 17.4773L178.41 17.945H178.565C178.651 17.945 178.726 17.9408 178.73 17.9351Z"
        fill="#C6B7FF"
      />
      <path
        d="M175.594 17.4773L175.59 17.0083L175.428 17.004L175.267 16.9998V17.4731V17.945H175.432H175.597L175.594 17.4773Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.416 17.7872V17.6774H179.301H179.186V17.783V17.8887H179.318C179.318 17.8887 179.265 17.8915 179.318 17.8929L179.416 17.8971V17.7872Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.807 17.7915V17.6774H174.692H174.577V17.783V17.8887H174.669C174.72 17.8887 174.771 17.8929 174.784 17.8971C174.804 17.9042 174.807 17.8901 174.807 17.7915Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.66 17.4224C179.66 17.3844 179.771 17.2646 179.854 17.2111L179.944 17.1519L179.888 17.1224C179.815 17.0843 179.697 16.9702 179.674 16.9167C179.664 16.8928 179.653 16.8745 179.647 16.8745C179.641 16.8745 179.626 16.8956 179.611 16.9223C179.577 16.9843 179.452 17.1083 179.399 17.1308C179.35 17.1519 179.348 17.1618 179.39 17.1801C179.448 17.2055 179.558 17.3111 179.597 17.3759C179.633 17.4351 179.66 17.4562 179.66 17.4224Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.416 17.3548C174.455 17.3013 174.507 17.252 174.561 17.2167C174.646 17.1632 174.666 17.1421 174.63 17.1421C174.594 17.1407 174.473 17.0407 174.413 16.959L174.351 16.8759L174.306 16.9449C174.252 17.0266 174.159 17.1083 174.089 17.1379L174.04 17.159L174.086 17.1787C174.146 17.2027 174.277 17.3252 174.313 17.3886C174.327 17.4154 174.343 17.4379 174.347 17.4379C174.351 17.4379 174.383 17.3999 174.416 17.3548Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.907 16.9097C173.941 16.8392 174.038 16.7406 174.105 16.7082L174.161 16.6801L174.121 16.6646C174.066 16.642 173.957 16.5307 173.913 16.4547L173.878 16.3941L173.841 16.4547C173.794 16.5336 173.695 16.6265 173.624 16.6603C173.57 16.6871 173.568 16.6885 173.603 16.6984C173.667 16.7181 173.766 16.8012 173.817 16.8801C173.844 16.9223 173.871 16.9576 173.875 16.959C173.88 16.959 173.894 16.9364 173.907 16.9097Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.191 16.9266C180.191 16.9181 180.207 16.8801 180.227 16.8421L180.263 16.7758H180.169H180.076L180.119 16.8421C180.144 16.8787 180.162 16.9167 180.162 16.9266C180.162 16.9364 180.168 16.9449 180.177 16.9449C180.184 16.9449 180.191 16.9364 180.191 16.9266Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.847 16.6871C174.912 16.6237 174.965 16.5632 174.965 16.5533C174.965 16.5434 174.805 16.3758 174.609 16.18C174.414 15.9842 174.205 15.7757 174.146 15.7152L174.039 15.6039L173.914 15.7363L173.788 15.8673L173.907 15.987C173.973 16.0532 174.136 16.218 174.271 16.3533C174.405 16.4885 174.56 16.6463 174.613 16.7026C174.666 16.7575 174.715 16.804 174.719 16.804C174.725 16.804 174.781 16.7519 174.847 16.6871Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.529 16.5463C179.66 16.4124 179.851 16.218 179.952 16.1138C180.056 16.0096 180.194 15.8701 180.258 15.8039L180.377 15.6828L180.264 15.5673C180.202 15.5039 180.146 15.4518 180.139 15.4518C180.132 15.4518 180.08 15.4954 180.026 15.5475C179.917 15.6532 179.243 16.3223 179.11 16.4603L179.026 16.5463L179.143 16.6688C179.207 16.735 179.268 16.7899 179.278 16.7885C179.286 16.7885 179.4 16.6787 179.529 16.5463Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.184 16.635C180.277 16.6294 180.308 16.6237 180.29 16.6139C180.256 16.5927 180.206 16.5195 180.186 16.4617L180.168 16.4096L180.119 16.4814C180.094 16.5209 180.046 16.5716 180.015 16.5941C179.983 16.6167 179.966 16.6364 179.977 16.6364C180.033 16.642 180.065 16.642 180.184 16.635Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.952 16.4166C181.023 16.3955 181.099 16.3307 181.135 16.2645C181.146 16.242 181.159 16.1898 181.163 16.1476C181.188 15.9123 180.947 15.7391 180.725 15.8321C180.599 15.8856 180.522 15.9983 180.522 16.1279C180.522 16.1856 180.567 16.2899 180.612 16.3363C180.691 16.4194 180.836 16.4533 180.952 16.4166Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.261 16.418C173.346 16.3955 173.408 16.3406 173.452 16.2476C173.495 16.1589 173.495 16.0828 173.452 15.994C173.412 15.9081 173.372 15.8715 173.28 15.8306C173.158 15.7785 173.006 15.818 172.915 15.9236C172.716 16.1631 172.952 16.5026 173.261 16.418Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.744 15.556L173.862 15.4348L173.822 15.3912C173.799 15.3658 173.69 15.2545 173.578 15.1418C173.333 14.8953 173.002 14.5573 172.9 14.4516L172.827 14.3741L172.702 14.4953C172.608 14.5883 172.581 14.6221 172.59 14.639C172.608 14.67 173.602 15.6771 173.615 15.6771C173.621 15.6771 173.678 15.6222 173.744 15.556Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.655 15.3855V15.2263H181.497H181.339V15.3799V15.5348L181.497 15.5391L181.655 15.5433V15.3855Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.682 15.3855V15.2263H172.524H172.366V15.3799V15.5348L172.524 15.5391L172.682 15.5433V15.3855Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.903 15.1602C181.361 14.6967 181.425 14.6291 181.425 14.6178C181.425 14.6122 181.374 14.5559 181.31 14.4911L181.196 14.3741L180.75 14.815L180.304 15.2559L180.43 15.3827L180.557 15.5109L180.903 15.1602Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.751 14.2276L181.854 14.1192L181.745 14.0163L181.638 13.9121L181.529 14.0206L181.418 14.1276L181.526 14.2333C181.585 14.291 181.636 14.3389 181.641 14.3375C181.645 14.3375 181.694 14.2868 181.751 14.2276Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.495 14.2333L172.603 14.1276L172.495 14.022L172.387 13.9178L172.275 14.0234L172.162 14.129L172.268 14.2333C172.325 14.291 172.376 14.3389 172.38 14.3389C172.384 14.3389 172.436 14.291 172.495 14.2333Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.155 13.798C176.259 13.6924 176.26 13.6896 176.237 13.6572C176.175 13.5642 176.201 13.4191 176.295 13.3402L176.343 13.298V11.3836V9.46791L176.569 9.23267C176.694 9.10308 176.836 8.95376 176.885 8.89882L176.975 8.80163V7.90152V7H176.738H176.501V7.63247V8.26494L176.537 8.2734C176.602 8.28889 176.672 8.36355 176.695 8.44243C176.714 8.50723 176.715 8.52272 176.695 8.58611C176.684 8.62414 176.656 8.67344 176.635 8.69317C176.592 8.73402 176.504 8.77487 176.461 8.77487C176.445 8.77487 176.369 8.83966 176.28 8.92981L176.128 9.08476L176.125 11.2935L176.121 13.5008H175.887C175.759 13.4994 175.654 13.5022 175.654 13.5078C175.656 13.5121 175.745 13.6022 175.852 13.7093L176.049 13.9037L176.155 13.798Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.52 13.5952C176.534 13.5811 176.544 13.5529 176.544 13.5318C176.544 13.491 176.496 13.4374 176.458 13.4374C176.422 13.4374 176.372 13.491 176.372 13.529C176.372 13.6051 176.471 13.6487 176.52 13.5952Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.99 12.2753V12.1555H179.825H179.66V12.2753V12.395H179.825H179.99V12.2753Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.242 12.3697C174.378 12.3063 174.427 12.1457 174.348 12.0175C174.292 11.9274 174.183 11.8907 174.068 11.9231C173.986 11.9457 173.943 11.9837 173.91 12.0598C173.824 12.2626 174.038 12.4626 174.242 12.3697Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.308 12.3697C179.312 12.3655 179.315 12.2838 179.315 12.188V12.0133L179.146 12.0175L178.978 12.0218L178.973 12.2021L178.969 12.3824L179.135 12.3795C179.226 12.3781 179.303 12.3725 179.308 12.3697Z"
        fill="#C6B7FF"
      />
      <path
        d="M175.037 12.1978V12.0147H174.864H174.691L174.695 12.195L174.699 12.3739L174.867 12.3781L175.037 12.3824V12.1978Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.634 12.3007C173.64 12.2964 173.644 12.2232 173.644 12.1387V11.9865H172.876H172.108V12.1485V12.3105H172.866C173.284 12.3105 173.63 12.3063 173.634 12.3007Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.914 12.1415V11.9865H181.371H180.827L180.667 11.8344C180.578 11.7513 180.507 11.6766 180.505 11.6682C180.505 11.6611 180.504 11.2456 180.504 10.7441C180.504 10.2441 180.499 9.82711 180.494 9.82006C180.489 9.81302 180.217 9.53975 179.889 9.21295C179.562 8.88615 179.289 8.60583 179.285 8.58752C179.279 8.57062 179.279 8.20578 179.283 7.77897L179.29 7H179.14C178.995 7 178.988 7.00141 178.979 7.0324C178.975 7.0493 178.97 7.60007 178.97 8.2579V9.45101L179.339 9.45241L179.71 9.45523L179.951 9.69751L180.192 9.93839L180.191 10.861V11.7837L180.443 12.0401L180.697 12.2964H181.305H181.914V12.1415ZM179.157 9.07349V8.92559L179.224 8.98616C179.311 9.06223 179.443 9.20027 179.444 9.21576C179.444 9.22281 179.379 9.22563 179.301 9.22281L179.157 9.21999V9.07349Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.768 11.7809C179.808 11.7203 179.934 11.5921 179.98 11.5639L180.021 11.54L179.98 11.5146C179.959 11.5019 179.897 11.4456 179.844 11.3907L179.746 11.2906L179.669 11.3752C179.626 11.4217 179.565 11.4766 179.535 11.4977L179.479 11.5357L179.588 11.6456C179.649 11.7048 179.708 11.7696 179.719 11.7879L179.741 11.8217L179.768 11.7809Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.315 11.5921V11.4231H179.143H178.97V11.5836V11.7442L179.015 11.7527C179.039 11.7569 179.117 11.7611 179.187 11.7611H179.315V11.5921Z"
        fill="#C6B7FF"
      />
      <path
        d="M175.037 11.5893V11.4231H174.864H174.691L174.695 11.5893L174.699 11.7541L174.867 11.7555L175.037 11.7569V11.5893Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.349 11.6569C174.352 11.6541 174.352 11.6189 174.351 11.5808L174.345 11.5104L174.28 11.5048C174.246 11.502 174.214 11.5034 174.21 11.5062C174.207 11.509 174.204 11.5456 174.204 11.5879V11.6625H174.273C174.312 11.6625 174.346 11.6597 174.349 11.6569Z"
        fill="#C6B7FF"
      />
      <path
        d="M174.165 11.1836L174.515 10.8315H174.604H174.692V11.0005V11.1695H174.864H175.037V10.4328V9.69611L174.663 10.0623L174.29 10.4286V10.5286V10.6286L173.987 10.9272L173.684 11.2259H172.896H172.108V11.3808V11.5358H172.961H173.813L174.165 11.1836Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.914 11.3667V11.2118H181.311H180.706L180.71 11.3639L180.715 11.5146L181.313 11.5189L181.914 11.5217V11.3667Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.315 11.0075V10.8455H179.143H178.97V11.0075V11.1695H179.143H179.315V11.0075Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.795 10.8779C179.809 10.8484 179.832 10.83 179.863 10.8244C179.893 10.8174 179.904 10.8089 179.898 10.7934C179.894 10.7821 179.89 10.7483 179.89 10.7174V10.6624H179.771H179.653V10.7159C179.652 10.7441 179.646 10.7793 179.64 10.7934C179.631 10.8117 179.634 10.8174 179.657 10.8174C179.673 10.8174 179.705 10.8399 179.729 10.8695L179.771 10.9216L179.795 10.8779Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.806 10.685C173.91 10.6483 173.96 10.5723 173.96 10.4554V10.3877L174.498 9.85951L175.037 9.33127V8.16634V7H174.886H174.735V8.10295V9.2045L174.207 9.72146C173.917 10.0046 173.665 10.2412 173.648 10.2455C173.604 10.2596 173.519 10.3567 173.503 10.4145C173.454 10.5849 173.635 10.7455 173.806 10.685Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.355 10.6596C181.473 10.5934 181.503 10.4328 181.421 10.3117C181.385 10.2596 181.382 10.2427 181.382 10.1159V9.97642L180.636 9.24535L179.889 8.51568V7.75784V7H179.738H179.588V7.81982V8.63964L180.115 9.15942C180.406 9.44396 180.742 9.77358 180.861 9.8919L181.081 10.1046V10.1863C181.081 10.2483 181.072 10.2779 181.045 10.3187C181.005 10.3779 180.988 10.4455 181 10.5032C181.035 10.6582 181.219 10.7385 181.355 10.6596Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.114 10.6624C173.176 10.63 173.228 10.5385 173.228 10.4638C173.228 10.437 173.215 10.3877 173.199 10.3539L173.17 10.292L173.205 10.2483C173.225 10.2243 173.499 9.94825 173.815 9.63413L174.389 9.06363L174.391 8.03252V7H174.247H174.103V7.54373V8.08746L173.548 8.63541L172.994 9.18337H172.909H172.826V9.31719V9.45101H172.995H173.166L173.631 8.99039L174.096 8.53117L174.101 8.72556L174.105 8.92136L173.493 9.52144L172.883 10.1201V10.1905C172.882 10.2511 172.876 10.268 172.834 10.3074C172.747 10.3934 172.737 10.5173 172.813 10.6117C172.877 10.692 173.012 10.7145 173.114 10.6624Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.315 10.4483V10.2821H179.143H178.97V10.4441C178.97 10.6314 178.945 10.6103 179.174 10.6117L179.315 10.6131V10.4483Z"
        fill="#C6B7FF"
      />
      <path
        d="M172.61 9.98065V9.90176H172.546C172.485 9.90176 172.483 9.90317 172.474 9.94966C172.457 10.0342 172.467 10.0497 172.543 10.0539L172.61 10.0581V9.98065Z"
        fill="#C6B7FF"
      />
      <path
        d="M179.315 9.88203V9.71863H179.143H178.97V9.87358V10.0285H179.12C179.202 10.0285 179.279 10.0328 179.292 10.037C179.312 10.044 179.315 10.0257 179.315 9.88203Z"
        fill="#C6B7FF"
      />
      <path
        d="M181.339 9.1087C181.473 9.02136 181.479 8.83542 181.352 8.74246C181.252 8.67062 181.078 8.71147 181.022 8.82134C180.965 8.93121 181.012 9.07771 181.118 9.12138C181.191 9.15096 181.285 9.14673 181.339 9.1087Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.198 8.75514L176.258 8.69457L176.229 8.64105C176.182 8.55371 176.176 8.47624 176.214 8.40158C176.231 8.36636 176.267 8.32129 176.294 8.30157L176.343 8.26494V7.63247V7H176.235H176.127V7.90856C176.127 8.40862 176.129 8.81712 176.132 8.81712C176.135 8.81712 176.163 8.78895 176.198 8.75514Z"
        fill="#C6B7FF"
      />
      <path
        d="M176.498 8.58331C176.564 8.53824 176.522 8.42273 176.441 8.42273C176.403 8.42273 176.357 8.47344 176.357 8.51288C176.357 8.54669 176.416 8.60585 176.449 8.60585C176.458 8.60585 176.481 8.59599 176.498 8.58331Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.924 8.15506V7.85925H180.615H180.308L180.304 8.14943C180.301 8.3086 180.302 8.44242 180.305 8.44524C180.308 8.44806 180.449 8.45087 180.618 8.45087H180.924V8.15506Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.61 8.37763C173.605 8.33678 173.601 8.20296 173.601 8.08182V7.85925H173.294H172.985L172.981 8.1452C172.978 8.30156 172.978 8.43397 172.981 8.44101C172.984 8.44665 173.129 8.45087 173.302 8.45087H173.62L173.61 8.37763Z"
        fill="#C6B7FF"
      />
      <path
        d="M180.731 7.46203C180.726 7.44372 180.722 7.4085 180.722 7.38456C180.722 7.33807 180.722 7.33807 180.65 7.33807H180.578V7.41555V7.49302H180.659C180.736 7.49302 180.739 7.49161 180.731 7.46203Z"
        fill="#C6B7FF"
      />
      <path
        d="M173.299 7.41555V7.33807H173.227H173.155V7.41555V7.49302H173.227H173.299V7.41555Z"
        fill="#C6B7FF"
      />
      <line
        x1="189"
        y1="12.5"
        x2="211"
        y2="12.5"
        stroke="url(#paint1_linear_2039_7777)"
      />
      <line
        y1="-0.5"
        x2="22"
        y2="-0.5"
        transform="matrix(-1 0 0 1 165 13)"
        stroke="url(#paint2_linear_2039_7777)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2039_7777"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(186 9) rotate(90) scale(11.6985)"
        >
          <stop stopColor="#3D2B7E" />
          <stop offset="1" stopColor="#0C0620" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2039_7777"
          x1="189"
          y1="13.5"
          x2="211"
          y2="13.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F5CFF" />
          <stop offset="1" stopColor="#0F0E10" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2039_7777"
          x1="0"
          y1="0.5"
          x2="22"
          y2="0.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F5CFF" />
          <stop offset="1" stopColor="#0F0E10" />
        </linearGradient>
      </defs>
    </svg>
  );
};
